// components/ui/CartSkeleton.tsx

const CartSkeleton = () => {
  return (
    <div className="min-h-screen bg-background-muted/60 pb-20 animate-pulse">
      <div className="container-custom py-10">
        {/* Header */}
        <div className="flex items-center justify-between mb-10">
          <div className="h-8 w-48 bg-gray-200 rounded-xl" />
          <div className="h-5 w-20 bg-gray-200 rounded-lg" />
        </div>

        <div className="grid lg:grid-cols-3 gap-10">
          {/* LEFT SECTION — Cart Items */}
          <div className="lg:col-span-2 space-y-6">
            {[1, 2, 3].map((i) => (
              <div
                key={i}
                className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm"
              >
                <div className="flex gap-6">
                  {/* Image */}
                  <div className="w-28 h-36 bg-gray-200 rounded-xl" />

                  {/* Details */}
                  <div className="flex-1 flex flex-col justify-between">
                    <div className="space-y-2">
                      <div className="h-5 bg-gray-200 rounded w-2/3" />
                      <div className="h-4 bg-gray-200 rounded w-1/3" />
                      <div className="h-4 bg-gray-200 rounded w-1/4" />
                    </div>

                    {/* Quantity + Price */}
                    <div className="flex items-center justify-between mt-4">
                      {/* Qty controls */}
                      <div className="flex items-center gap-3">
                        <div className="flex items-center rounded-xl border border-gray-200 overflow-hidden">
                          <div className="px-3 py-2 bg-gray-200 h-9 w-9" />
                          <div className="px-4 h-9 bg-gray-200 w-10" />
                          <div className="px-3 py-2 bg-gray-200 h-9 w-9" />
                        </div>

                        <div className="h-6 w-6 bg-gray-200 rounded" />
                      </div>

                      {/* Price */}
                      <div className="text-right space-y-2">
                        <div className="h-5 bg-gray-200 rounded w-20" />
                        <div className="h-4 bg-gray-200 rounded w-16" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* RIGHT SECTION — ORDER SUMMARY */}
          <div className="lg:col-span-1">
            <div className="sticky top-24 rounded-2xl p-6 shadow-lg border border-gray-200 bg-background-soft space-y-6">
              <div className="h-6 w-32 bg-gray-200 rounded" />

              {/* Summary rows */}
              <div className="space-y-3">
                <div className="flex justify-between">
                  <div className="h-4 w-20 bg-gray-200 rounded" />
                  <div className="h-4 w-16 bg-gray-200 rounded" />
                </div>

                <div className="flex justify-between">
                  <div className="h-4 w-20 bg-gray-200 rounded" />
                  <div className="h-4 w-16 bg-gray-200 rounded" />
                </div>

                <div className="flex justify-between">
                  <div className="h-4 w-20 bg-gray-200 rounded" />
                  <div className="h-4 w-16 bg-gray-200 rounded" />
                </div>
              </div>

              {/* Coupon input */}
              <div className="border-t pt-5 space-y-3">
                <div className="h-4 w-28 bg-gray-200 rounded" />

                <div className="flex gap-2">
                  <div className="h-10 w-full bg-gray-200 rounded-xl" />
                  <div className="h-10 w-20 bg-gray-300 rounded-xl" />
                </div>
              </div>

              {/* Total */}
              <div className="border-t pt-5 flex justify-between">
                <div className="h-5 w-16 bg-gray-200 rounded" />
                <div className="h-7 w-24 bg-gray-200 rounded" />
              </div>

              {/* Checkout Buttons */}
              <div className="space-y-3">
                <div className="h-12 w-full bg-gray-300 rounded-xl" />
                <div className="h-12 w-full bg-gray-200 rounded-xl" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartSkeleton;
